export class DeviceRegistration {
  static readonly type = '[Device] Registration';
  constructor(public deviceId: string) {}
}

export class DeviceRemoval {
  static readonly type = '[Device] Removal';
}
